import { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import useOrderService from "../../../hooks/useOrderService";

interface RenewalDeleteConfirmationProps {
  orderItemId: string;
}

const RenewalDeleteConfirmation = ({ orderItemId }: RenewalDeleteConfirmationProps) => {
  const navigate = useNavigate();
  const orderService = useOrderService();
  const [confirmed, setConfirmed] = useState(false);

  useEffect(() => {
    if (!confirmed) return;
    const timer = setTimeout(() => navigate("/"), 3000);
    return () => clearTimeout(timer);
  }, [confirmed]);

  const handleConfirm = async () => {
    await orderService.SetOrderItemDataDeleted(orderItemId);
    setConfirmed(true);
  };

  if (confirmed) {
    return (
      <>
        <h2>Thank you</h2>
        <p>Your response has been recorded. You will be redirected shortly.</p>
      </>
    );
  }

  return (
    <div
      style={{
        border: "1px solid #dee2e6",
        borderRadius: "8px",
        padding: "2rem",
        maxWidth: "480px",
        width: "100%",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
      }}
    >
      <h4>Delete Data</h4>
      <p>
        I confirm that the data associated with my order has been permanently
        deleted from my system.
      </p>
      <div style={{ display: "flex", justifyContent: "center", gap: "1rem" }}>
        <Button variant="danger" onClick={handleConfirm}>
          Delete Data
        </Button>
      </div>
    </div>
  );
};

export default RenewalDeleteConfirmation;
